import { render } from "./DashboardEquipmentPage.vue?vue&type=template&id=157ace0c&scoped=true"
import script from "./DashboardEquipmentPage.vue?vue&type=script&lang=js"
export * from "./DashboardEquipmentPage.vue?vue&type=script&lang=js"

import "./DashboardEquipmentPage.vue?vue&type=style&index=0&id=157ace0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157ace0c"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader});
